<template>
  <section class="viewsrhqyNotice_Announcement p-4 space-y-2">
    <viewTitle title="业务管理 / 公告管理" :showReturn="false" />
    <div>
      <el-button v-if="baseInfo.is_main_com === 0" v-has="['c-notice-record-add']" type="primary" @click="onAdd" size="small">新建消息</el-button>
      <el-button v-if="baseInfo.is_main_com === 0" v-has="['c-notice-record-delete']" type="danger" @click="onDelete" size="small">删除</el-button>
    </div>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="基地" v-if="baseInfo.is_main_com === 1">
        <el-select class="w-40" clearable v-model="queryParam.delivery_com_id">
          <el-option
            v-for="item in com_list"
            :key="item.com_id"
            :label="item.com_name"
            :value="item.com_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发送方式">
        <el-select
          clearable
          class="w-40"
          v-model="queryParam.send_type"
          placeholder="请选择发送方式"
        >
          <el-option
            v-for="(label, value) in sendTypes"
            :key="value"
            :label="label"
            :value="value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          class="w-40"
          clearable
          v-model="queryParam.state"
          placeholder="请选择状态"
        >
          <el-option
            v-for="(label, value) in stateTypes"
            :key="value"
            :label="label"
            :value="value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="推送时间">
        <el-date-picker
          class="!w-96"
          style="margin-bottom: 10px;"
          v-model="timeRange"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-input
          clearable
          suffix-icon="el-icon-search"
          v-model="queryParam.title"
          placeholder="请输入消息概要"
          class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshData" size="small"
          >刷新数据</el-button
        >
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
      class="mt-4"
      :isIndex="false"
      :isSelection="true"
      :selection.sync="rowKeySelection"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="id"
      @loadPage="loadData"
    >
      <template slot="send_time" slot-scope="{ row }">
        {{ row.send_time | timeFormat }}
      </template>
      <template slot="action" slot-scope="{ row }">
        <div class="space-x-4">
          <c-link
            v-if="row.state === 1 && baseInfo.is_main_com === 0"
            @click="onCancelNotice(row)"
            v-has="['c-notice-record-cancel']"
            type="primary"
            label="取消发布"
          ></c-link>
          <c-link v-has="['c-notice-record-again']" v-if="row.state === 2 && baseInfo.is_main_com === 0" type="primary" @click="onAgainNotifce(row)">重新发布</c-link>
          <c-link v-has="['c-notice-record-update']" v-if="row.state === 2 && baseInfo.is_main_com === 0" type="primary" @click="onEditNotifce(row)">编辑</c-link>
          <c-link
            @click="onViewNotice(row)"
            v-has="['c-notice-record-detail']"
            type="primary"
            label="查看"
          ></c-link>
        </div>
      </template>
    </c-table>
    <createMessage ref="createMessage" @ok="refreshData"/>
    <viewMessage ref="viewMessage"/>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import createMessage from './common/createMessage.vue';
import viewMessage from './common/viewMessage.vue';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      sendTypes: {
        1: "按所有",
        2: "按基地"
      },
      stateTypes: {
        1: "已发布",
        2: "已取消"
      },
      columns: [
        { label: "消息标题", prop: "title" },
        {
          label: "发送方式",
          prop: "send_type",
          formatData: row => this.sendTypes[row.send_type]
        },
        { label: "基地", prop: "delivery_com_name" },
        { 
          label: "发送范围", 
          prop: "send_scope",
          formatData: row => {
            if(row.send_type === 1){
              return '按所有';
            }else{
              return row.send_scope;
            }
          }
        },
        { label: "发送人", prop: "create_name" },
        { label: "推送时间", prop: "send_time" },
        {
          label: "状态",
          prop: "state",
          formatData: row => this.stateTypes[row.state]
        },
        { label: "操作", prop: "action" }
      ],
      deleteConfig: {
        title: "删除", // 标题
        content: "确认删除？删除后数据将不可恢复！",
        url: "/api/queue/admin/delete_notice",
        paramsKey: "ids", // 提交参数的key
        paramsType: 'string'
      },
      fetchDataEvent: params =>
        this.$common.http({
          url: "/api/queue/admin/query_notice",
          data: params
        })
    };
  },
  methods: {
    onCancelNotice(row) {
      this.$confirm("确认取消公告吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/cancel_notice",
            data: {
              id: row.id
            }
          });
          this.$common.pcToastSuccess(`操作成功`);
          this.refreshData();
        } catch (error) {}
      });
    },
    onViewNotice(row) {
      this.$refs.viewMessage.onOpen(row);
    },
    onAdd() {
      this.$refs.createMessage.onOpen();
    },
    onEditNotifce(row) {
      this.$refs.createMessage.onOpen({
        ...row,
        send_role: JSON.parse(row.send_role) || []
      });
    },
    onAgainNotifce(row) {
      this.$confirm("确认发送消息通知吗？将推送到给用户！", "发送确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning" 
      }).then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/again_notice",
            data: {
              id: row.id
            }
          });
          this.$common.pcToastSuccess(`操作成功`);
          this.refreshData();
        } catch (error) {}
      });
    }
  },
  components: {
    createMessage,
    viewMessage
  },
  mixins: [initListMinxin, mixinTableLyout],
  computed: {
    ...mapGetters(["baseInfo"])
  }
};
</script>
<style lang="less" scoped></style>
